import { HttpClient, HttpContext, HttpErrorResponse, HttpEvent, HttpEventType } from '@angular/common/http';
import { SKIP_ERROR_SNACKBAR } from 'src/app/core/interceptors/http-context-tokens';
import { TranslateService } from '@ngx-translate/core';

import { Injectable } from '@angular/core';
import { Observable, of, throwError } from 'rxjs';
import { catchError, map, switchMap, tap } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { ItemViewModel } from 'src/app/pages/items/model/item-view-model';
import { MatSnackBar } from '@angular/material/snack-bar';
import { from } from 'rxjs';
import { LoggerService } from 'src/app/services/logger.service';
import { compressBase64Image, SIGNATURE_COMPRESSION_CONFIG } from '../../shared/utils/image-compression.util';
import { browserTimeZone } from 'src/app/shared/utils/browser-time-zone';
import { withPlotDate } from 'src/app/shared/utils/sale-dated-rows';
import { RecurringInvoiceScheduleRequest, RecurringQuoteScheduleRequest } from 'src/app/quote/recurring-schedule/recurring-schedule.model';

export interface InventoryRequest {
  ids: number[];
}

/** Card #582: the per-quote History drawer's filter, matching quotes#596's `quoteLogs` endpoint. */
export type QuoteLogFilter = 'all' | 'activity' | 'emails';

export interface QuoteLogItem {
  id: string;
  event: string;
  user_id: string | null;
  member_name: string | null;
  from_value: string | null;
  to_value: string | null;
  recipient: string | null;
  reason: string | null;
  created_at: string;
}

export interface QuoteLogPage {
  items: QuoteLogItem[];
  next_offset: number | null;
}

export interface QuoteLogResponse {
  status: number;
  status_code: number;
  message: string;
  data: QuoteLogPage;
}
@Injectable({
  providedIn: 'root'
})

export class QuoteTemplateService {
  BASE_URL: string;
  QUOTE_TEMPLATE_URL:string;
  lead:string;
  cloneTemplateSuffix = '';
  copyTemplateSuffix = '';
  mailBox_url=''
  ITEMS=''
  constructor(
    private http: HttpClient,
    public snackbar: MatSnackBar,
    private logger: LoggerService,
    private translateService: TranslateService
  ) {
    this.BASE_URL = environment.API_URL;
    this.QUOTE_TEMPLATE_URL= environment.QUOTE_MANAGEMENT_URL;
    this.lead = environment.LEAD_MANAGEMENT_URL;
    this.mailBox_url=environment.MAILBOX_MANAGEMENT_URL;
    this.ITEMS= environment.ITEM_MODULE_URL;
  }


  customerCustomFieldList(data: any = ''): Observable<any> {
    return this.http.post(this.QUOTE_TEMPLATE_URL + '/customFieldList', data).pipe(
      map((response: any) => {
        return response;
      }),
      catchError((err: any) => throwError(() => err))
    );
  }

  contactCustomFieldList(data: any = ''): Observable<any> {
    return this.http.post(this.QUOTE_TEMPLATE_URL + '/eQuote-template/contactCustoms', data).pipe(
      map((response: any) => {
        return response;
      }),
      catchError((err: any) => throwError(() => err))
    );
  }

  get_Lead_Form(data: any, hideLoader = false): Observable<any> {
    const options = hideLoader ? { headers: { 'X-Hide-Loader': 'true' } } : {};
    return this.http.get(`${this.QUOTE_TEMPLATE_URL}/lead-template/viewTemplate/${data}`, options).pipe(
      map((response: any) => {
        return response;
      }),
      catchError((err: any) => throwError(() => err))
    );
  }

  get_eQuote_Form(data: any, hideLoader = false): Observable<any> {
    const options = hideLoader ? { headers: { 'X-Hide-Loader': 'true' } } : {};
    return this.http.get(`${this.QUOTE_TEMPLATE_URL}/eQuote-template/viewTemplate/${data}`, options).pipe(
      map((response: any) => {
        return response;
      }),
      catchError((err: any) => throwError(() => err))
    );
  }

  get_Payment(data: any, hideLoader = false): Observable<any> {
    const options = hideLoader ? { headers: { 'X-Hide-Loader': 'true' } } : {};
    return this.http.get(`${this.QUOTE_TEMPLATE_URL}/paymentsListing/viewPayment/${data}`, options).pipe(
      map((response: any) => {
        return response;
      }),
      catchError((err: any) => throwError(() => err))
    );
  }

  /** `view: 'reports'`: only the columns the Reports page reads (card #265); the server ignores it if it doesn't know it. */
  get_all_Payment(view?: 'reports'): Observable<any> {
    const options = view ? { params: { view } } : {};
    return this.http.get(`${this.QUOTE_TEMPLATE_URL}/paymentsListing/allPayment`, options).pipe(
      map((response: any) => {
        return response;
      }),
      catchError((err: any) => throwError(() => err))
    );
  }

  get_contact_Payment(data: any): Observable<any> {
    return this.http.get(`${this.QUOTE_TEMPLATE_URL}/paymentsListing/contactPayment/${data}`).pipe(
      map((response: any) => {
        return response;
      }),
      catchError((err: any) => throwError(() => err))
    );
  }

 
  get_uploads_Form(data: any): Observable<any> {
    return this.http.post(`${this.QUOTE_TEMPLATE_URL}/eQuote-template/find/uploadAttachments`,data).pipe(
      map((response: any) => {
        return response;
      }),
      catchError((err: any) => throwError(() => err))
    );
  }

  viewContact(data: any): Observable<any> {
    return this.http.get(`${this.QUOTE_TEMPLATE_URL}/eQuote-template/view/${data}`).pipe(
      map((response: any) => {
        return response;
      }),
      catchError((err: any) => throwError(() => err))
    );
  }
  

  merchantcustomerInfo(id, hideLoader = false) {
    const options = hideLoader ? { headers: { 'X-Hide-Loader': 'true' } } : {};
    return this.http.get(this.BASE_URL + '/merchantcustomer/' + id, options)
      .pipe(
        map((response: any) => {
          return response;
        }),
        catchError((err: any) => throwError(() => err))
      );
  }

  getCustomer(resource: any = ''): Observable<any> {
    if (resource && typeof resource === 'object') {
      if (resource.limit === '') {
        resource.limit = 10;
      }
    }
    return this.http.post(`${this.BASE_URL}/merchantcustomer/list`, resource).pipe(
      tap(
        data => data,
        error => error
      )
    );
  }

  get_Quote_List_id(data: any): Observable<any> {
    return this.http.get(
      `${this.QUOTE_TEMPLATE_URL}/quotesListing/viewListing/${data}`
    ).pipe(
      map((response: any) => {
        return response;
      }),
      catchError((err: any) => throwError(() => err))
    );
  }

  get_signature_image(data: any): Observable<any> {
    return this.http.get(
      `${this.QUOTE_TEMPLATE_URL}/quotesListing/getSignatureImage/${data}`
    ).pipe(
      map((response: any) => {
        return response;
      }),
      catchError((err: any) => throwError(() => err))
    );
  }

  get_Quote_maximum(data: any): Observable<any> {
    return this.http.post(this.QUOTE_TEMPLATE_URL +'/quotesListing/getMaximumNumber', data).pipe(
      map((response: any) => {
        return response;
      }),
      catchError((err: any) => throwError(() => err))
    );
  }

  getMaximumNumberInvoices(data: any): Observable<any> {
    return this.http.post(this.QUOTE_TEMPLATE_URL +'/quotesListing/getMaximumNumberInvoices', data).pipe(
      map((response: any) => {
        return response;
      }),
      catchError((err: any) => throwError(() => err))
    );
  }
  

  get_Quote_all_maximum(data:any=''): Observable<any> {
    
    return this.http.post(this.QUOTE_TEMPLATE_URL +'/quotesListing/getMaximumNumberAll',data).pipe(
      map((response: any) => {
        return response;
      }),
      catchError((err: any) => throwError(() => err))
    );
  }

  get_Quote_all_maximum_invoices(data:any=''): Observable<any> {
    
    return this.http.post(this.QUOTE_TEMPLATE_URL +'/quotesListing/getMaximumNumberAllInvoices',data).pipe(
      map((response: any) => {
        return response;
      }),
      catchError((err: any) => throwError(() => err))
    );
  }

  // get_Quote_id(type:any): Observable<any> {
  //   return this.http.post(`${this.QUOTE_TEMPLATE_URL}/quoteId`,type).pipe(
  //     map((response: any) => {
  //       return response;
  //     }),
  //     catchError((err: any) => {
  //       return err;
  //     })
  //   );
  // }

  get_Quote_id(data: any): Observable<any> {
    return this.http.post(`${this.QUOTE_TEMPLATE_URL}/quoteId`, data).pipe(
      map((response: any) => {
        return response;
      }),
      catchError((err: any) => throwError(() => err))
    );
  }

  update_quote_listing(data: any): Observable<any> {
    return this.http.post(`${this.QUOTE_TEMPLATE_URL}/quotesListing/updateListing`, data).pipe(
      map((response: any) => {
        return response;
      }),
      catchError((err: any) => throwError(() => err))
    );
  }

  // Lightweight "mark quote as viewed" — hits the automation-free updateLastView endpoint.
  updateLastView(data: any): Observable<any> {
    return this.http.post(`${this.QUOTE_TEMPLATE_URL}/quotesListing/updateLastView`, data).pipe(
      map((response: any) => {
        return response;
      }),
      catchError((err: any) => throwError(() => err))
    );
  }

  update_quote_stage_dialog(data: any): Observable<any> {
    return this.http.post(`${this.QUOTE_TEMPLATE_URL}/quotesListing/quoteStagesUpdate`, data).pipe(
      map((response: any) => {
        return response;
      }),
      catchError((err: any) => throwError(() => err))
    );
  }

  update_payment_data(data: any): Observable<any> {
    return this.http.post(`${this.QUOTE_TEMPLATE_URL}/paymentsListing/updatePayment`, data).pipe(
      map((response: any) => {
        return response;
      }),
      catchError((err: any) => throwError(() => err))
    );
  }

  add_payment_data(data: any): Observable<any> {
    return this.http.post(`${this.QUOTE_TEMPLATE_URL}/paymentsListing/addPayment`, data).pipe(
      map((response: any) => {
        return response;
      }),
      catchError((err: any) => throwError(() => err))
    );
  }

  del_payment_data(data: any): Observable<any> {
    return this.http.post(`${this.QUOTE_TEMPLATE_URL}/paymentsListing/delPayment`, data).pipe(
      map((response: any) => {
        return response;
      }),
      catchError((err: any) => throwError(() => err))
    );
  }

  update_payment_status(data: any): Observable<any> {
    return this.http.post(`${this.QUOTE_TEMPLATE_URL}/paymentsListing/updatePaymentStatus`, data).pipe(
      map((response: any) => {
        return response;
      }),
      catchError((err: any) => throwError(() => err))
    );
  }

  // updateListingStatus

  update_quote_listing_status(data: any): Observable<any> {
    return this.http.post(`${this.QUOTE_TEMPLATE_URL}/quotesListing/updateListingStatus`, data).pipe(
      map((response: any) => {
        return response;
      }),
      catchError((err: any) => throwError(() => err))
    );
  }

  /**
   * Centralized processing for jobProgress socket events.
   * Handles optional signature compression and calls update_quote_listing_status.
   */
  processJobProgress(data: any): Observable<any> {
    if (!data?.invoice_id) return of(null);

    // Use from() to convert the async compression logic into an observable flow
    return from((async () => {
      let signatureImage = data?.signature_image;

      // If image is present and looks like a large base64, compress it
      if (typeof signatureImage === 'string' && signatureImage.length > SIGNATURE_COMPRESSION_CONFIG.SIZE_THRESHOLD) {
        try {
          signatureImage = await compressBase64Image(
            signatureImage,
            SIGNATURE_COMPRESSION_CONFIG.MAX_WIDTH,
            SIGNATURE_COMPRESSION_CONFIG.MAX_HEIGHT
          );
        } catch (e) {
          this.logger.error('Error compressing signature image in service:', e);
        }
      }

      const payload = {
        actions: data?.status,
        invoice_id: data?.invoice_id,
        merchant_id: data?.merchant_id,
        signature_image: signatureImage,
      };

      console.log(payload, 'Processed socket payload');
      return payload;
    })()).pipe(
      switchMap(payload => {
        if (!payload) return of(null);
        return this.update_quote_listing_status(payload);
      }),
      catchError(err => {
        this.logger.error('Error processing job progress:', err);
        return of(null);
      })
    );
  }

  update_contact_view_date(data: any): Observable<any> {
    return this.http.post(`${this.QUOTE_TEMPLATE_URL}/quotesListing/updateContactViewdate`, data).pipe(
      map((response: any) => {
        return response;
      }),
      catchError((err: any) => throwError(() => err))
    );
  }

  sendNotification(resource) {
    return this.http.patch(this.BASE_URL + '/item/item_image', resource)
      .pipe(
        map((response: any) => {
          return response;
        }),
        catchError((err: any) => throwError(() => err))
      );
  }

  update_Lead_Form(data: any, hideLoader = false): Observable<any> {
    const shouldHide = hideLoader || data?.hideLoader || false;
    const options = shouldHide ? { headers: { 'X-Hide-Loader': 'true' } } : {};
    return this.http.post(`${this.QUOTE_TEMPLATE_URL}/lead-template/updateTemplate`, data, options).pipe(
      map((response: any) => {
        return response;
      }),
      catchError((err: any) => throwError(() => err))
    );
  }

  update_eQuote_Form(data: any, hideLoader = false): Observable<any> {
    const shouldHide = hideLoader || data?.hideLoader || false;
    const options = shouldHide ? { headers: { 'X-Hide-Loader': 'true' } } : {};
    return this.http.post(`${this.QUOTE_TEMPLATE_URL}/eQuote-template/updateTemplate`, data, options).pipe(
      map((response: any) => {
        return response;
      }),
      catchError((err: any) => throwError(() => err))
    );
  }

  quote_listing_Form(data: any): Observable<any> {
    return this.http.post(`${this.QUOTE_TEMPLATE_URL}/quotesListing/quotelisting`, data).pipe(
      map((response: any) => {
        return response;
      }),
      catchError((err: any) => throwError(() => err))
    );
  }

  revertQuote(data: any): Observable<any> {
    return this.http.post(`${this.QUOTE_TEMPLATE_URL}/quotesListing/revertQuote`, data).pipe(
      map((response: any) => {
        return response;
      }),
      catchError((err: any) => throwError(() => err))
    );
  }

  payment_listing_add(data: any): Observable<any> {
    return this.http.post(`${this.QUOTE_TEMPLATE_URL}/paymentsListing/paymentListing`, data).pipe(
      map((response: any) => {
        return response;
      }),
      catchError((err: any) => throwError(() => err))
    );
  }

  eQuote_listing(data: any): Observable<any> {
    return this.http.post(`${this.QUOTE_TEMPLATE_URL}/quotesListing/quotelisting/eQuote`, data).pipe(
      map((response: any) => {
        return response;
      }),
      catchError((err: any) => throwError(() => err))
    );
  }

  send_member_email(data: any): Observable<any> {
    return this.http.post(`${this.QUOTE_TEMPLATE_URL}/quotesListing/sendMemberEmail`, data).pipe(
      map((response: any) => {
        return response;
      }),
      catchError((err: any) => throwError(() => err))
    );
  }

  

  quoteWithNewVersion(data: any): Observable<any> {
    return this.http.post(`${this.QUOTE_TEMPLATE_URL}/quotesListing/quoteWithNewVersion`, data).pipe(
      map((response: any) => {
        return response;
      }),
      catchError((err: any) => throwError(() => err))
    );
  }

  savePdf(data: any): Observable<any> {
    return this.http.post(`${this.QUOTE_TEMPLATE_URL}/quotesPdf/savePdf`, data).pipe(
      map((response: any) => {
        return response;
      }),
      catchError((err: any) => throwError(() => err))
    );
  }

  createQuoteFilter(data: any): Observable<any> {
    return this.http.post(`${this.QUOTE_TEMPLATE_URL}/quotesFilters/savefilters`, data).pipe(
      map((response: any) => {
        return response;
      }),
      catchError((err: any) => throwError(() => err))
    );
  }

  saveQuoteFilterList(data: any): Observable<any> {
    return this.http.post(`${this.QUOTE_TEMPLATE_URL}/quotesFilters/saveFilterList`, data).pipe(
      map((response: any) => {
        return response;
      }),
      catchError((err: any) => throwError(() => err))
    );
  }

  deleteQuoteFilter(data: any): Observable<any> {
    return this.http.post(`${this.QUOTE_TEMPLATE_URL}/quotesFilters/deleteSaveFilter`, data).pipe(
      map((response: any) => {
        return response;
      }),
      catchError((err: any) => throwError(() => err))
    );
  }

  sendMail(data: any): Observable<any> {
    return this.http.post(`${this.mailBox_url}/email/quote`, data).pipe(
      map((response: any) => {
        return response;
      }),
      catchError((err: any) => throwError(() => err))
    );
  }

  sendEmails(data: any): Observable<any> {
    return this.http.post(`${this.QUOTE_TEMPLATE_URL}/quotesListing/sendEmail`, data).pipe(
      tap(
        data => data,
        error => error
      )
    );
  }

  // Card #212: recurring-invoice schedules (quotes recurringInvoices/*). One request per
  // user action; the server is the only place a schedule is decided and run.
  getRecurringInvoiceSchedule(invoiceId: string): Observable<any> {
    const id = String(invoiceId || '').trim();
    if (!id) return throwError(() => ({ status: 400, error: { message: 'invoice id is required' } }));
    return this.http.get(`${this.QUOTE_TEMPLATE_URL}/recurringInvoices/schedule/${encodeURIComponent(id)}`);
  }

  saveRecurringInvoiceSchedule(body: RecurringInvoiceScheduleRequest): Observable<any> {
    return this.http.post(`${this.QUOTE_TEMPLATE_URL}/recurringInvoices/schedule`, body);
  }

  stopRecurringInvoiceSchedule(invoiceId: string): Observable<any> {
    const id = String(invoiceId || '').trim();
    if (!id) return throwError(() => ({ status: 400, error: { message: 'invoice id is required' } }));
    return this.http.post(`${this.QUOTE_TEMPLATE_URL}/recurringInvoices/stop`, { invoice_id: id });
  }

  // Card #34: recurring-QUOTE schedules (quotes recurringQuotes/*), the same engine as
  // recurring invoices. Addressed by the quote (listing) id; the server finds its schedule.
  getRecurringQuoteSchedule(listingId: string): Observable<any> {
    const id = String(listingId || '').trim();
    if (!id) return throwError(() => ({ status: 400, error: { message: 'quote id is required' } }));
    return this.http.get(`${this.QUOTE_TEMPLATE_URL}/recurringQuotes/schedule/${encodeURIComponent(id)}`);
  }

  saveRecurringQuoteSchedule(body: RecurringQuoteScheduleRequest): Observable<any> {
    return this.http.post(`${this.QUOTE_TEMPLATE_URL}/recurringQuotes/schedule`, body);
  }

  stopRecurringQuoteSchedule(listingId: string): Observable<any> {
    const id = String(listingId || '').trim();
    if (!id) return throwError(() => ({ status: 400, error: { message: 'quote id is required' } }));
    return this.http.post(`${this.QUOTE_TEMPLATE_URL}/recurringQuotes/stop`, { listing_id: id });
  }
  
  quote_pdf_list(data: any, hideLoader: boolean = true): Observable<any> {
    const payload = hideLoader ? { hideLoader: true, ...data } : data;
    return this.http.post(`${this.QUOTE_TEMPLATE_URL}/quotesPdf/quotepdfList`, payload).pipe(
      map((response: any) => {
        return response;
      }),
      catchError((err: any) => throwError(() => err))
    );
  }

  update_status(data: any): Observable<any> {
    return this.http.post(`${this.QUOTE_TEMPLATE_URL}/quotesPdf/updateStatus`, data).pipe(
      map((response: any) => {
        return response;
      }),
      catchError((err: any) => throwError(() => err))
    );
  }

  /**
   * Card #349: the public page's whole accept in ONE call (quotes PR card349-atomic-accept):
   * public-link status, listing status, signature and accepted date together, or nothing.
   * Answers { data: { accepted, alreadyAccepted } }; refuses with 409 QUOTE_EXPIRED,
   * 409 QUOTE_NOT_ACCEPTABLE, 404 QUOTE_NOT_FOUND or 500 ACCEPT_NOT_SAVED.
   */
  accept_quote(data: { invoice_id: string; signature_image?: string | null }): Observable<any> {
    // The page shows its own "Saving your acceptance…" and its own error with "Try again":
    // hideLoader (read by SpinnerInterceptor from the body; the server ignores it) keeps the
    // full-screen spinner away, SKIP_ERROR_SNACKBAR the raw-code snackbar.
    return this.http.post(`${this.QUOTE_TEMPLATE_URL}/quotesPdf/acceptQuote`, { hideLoader: true, ...data }, {
      withCredentials: true,
      context: new HttpContext().set(SKIP_ERROR_SNACKBAR, true),
    });
  }

  update_url(data: any): Observable<any> {
    return this.http.post(`${this.QUOTE_TEMPLATE_URL}/quotesPdf/updateUrl`, data).pipe(
      map((response: any) => {
        return response;
      }),
      catchError((err: any) => throwError(() => err))
    );
  }

  update_url_pdf(data: any): Observable<any> {
    return this.http.post(`${this.QUOTE_TEMPLATE_URL}/quotesPdf/updateStatusPdf`, data).pipe(
      map((response: any) => {
        return response;
      }),
      catchError((err: any) => throwError(() => err))
    );
  }

  update_payload(data: any): Observable<any> {
    return this.http.post(`${this.QUOTE_TEMPLATE_URL}/quotesPdf/updatePayload`, data).pipe(
      map((response: any) => {
        return response;
      }),
      catchError((err: any) => throwError(() => err))
    );
  }

  quote_pdf_notification(data: any): Observable<any> {
    return this.http.post(`http://localhost:5005/quotes_management/quotesPdf/quotepdfListNotification`, data).pipe(
      map((response: any) => {
        return response;
      }),
      catchError((err: any) => throwError(() => err))
    );
  }


  quoteInvoiceStatus(data: any): Observable<any> {
    return this.http.post(`${this.QUOTE_TEMPLATE_URL}/quotesListing/invoiceStatus`, data).pipe(
      map((response: any) => {
        return response;
      }),
      catchError((err: any) => throwError(() => err))
    );
  }

  quoteStatus(data: any): Observable<any> {
    return this.http.post(`${this.QUOTE_TEMPLATE_URL}/quotesListing/quoteStatus`, data).pipe(
      map((response: any) => {
        return response;
      }),
      catchError((err: any) => throwError(() => err))
    );
  }

  // Card #202: void many quotes in ONE request; the server does the per-quote work.
  bulkQuoteStatus(quoteIds: string[]): Observable<any> {
    return this.http.post(`${this.QUOTE_TEMPLATE_URL}/quotesListing/bulkQuoteStatus`, { quote_ids: quoteIds }).pipe(
      map((response: any) => response),
      catchError((err: any) => throwError(() => err))
    );
  }

  quoteStatusChange(data: any): Observable<any> {
    return this.http.post(`${this.QUOTE_TEMPLATE_URL}/quotesListing/quoteStatusChange`, data).pipe(
      map((response: any) => {
        return response;
      }),
      catchError((err: any) => throwError(() => err))
    );
  }

  saleStatus(data: any): Observable<any> {
    return this.http.post(`${this.QUOTE_TEMPLATE_URL}/quotesListing/salesStatus`, data).pipe(
      map((response: any) => {
        return response;
      }),
      catchError((err: any) => throwError(() => err))
    );
  }

  get_quote_listing_list(data: any): Observable<any> {
    const payload = typeof data === 'object' && data !== null ? { timezone: browserTimeZone(), ...data } : data;
    return this.http.post(`${this.QUOTE_TEMPLATE_URL}/quotesListing/quotelistingList`, payload).pipe(
      map((response: any) => {
        return response;
      }),
      catchError((err: any) => throwError(() => err))
    );
  }


  get_quote_listing_list_filters(data: any): Observable<any> {
    return this.http.post(`${this.QUOTE_TEMPLATE_URL}/quotesListing/quotelistingListFilters`, data).pipe(
      map((response: any) => {
        return response;
      }),
      catchError((err: any) => throwError(() => err))
    );
  }

  get_quote_listing_list_invoice(data: any): Observable<any> {
    const payload = typeof data === 'object' && data !== null ? { timezone: browserTimeZone(), ...data } : data;
    return this.http.post(`${this.QUOTE_TEMPLATE_URL}/quotesListing/quotelistingListInvoices`, payload).pipe(
      map((response: any) => {
        return response;
      }),
      catchError((err: any) => throwError(() => err))
    );
  }

  get_quote_listing_sales(data: any): Observable<any> {
    const payload = typeof data === 'object' && data !== null ? { timezone: browserTimeZone(), ...data } : data;
    return this.http.post(`${this.QUOTE_TEMPLATE_URL}/quotesListing/salesList`, payload).pipe(
      map((response: any) => {
        return response;
      }),
      catchError((err: any) => throwError(() => err))
    );
  }

  /** Card #440: agenda calendars. Body { kind: 'quote' | 'salesOrder', start, end } (ISO). */
  get_calendar_list(data: { kind: 'quote' | 'salesOrder'; start: string; end: string }): Observable<any> {
    return this.http.post(`${this.QUOTE_TEMPLATE_URL}/quotesListing/calendarList`, data).pipe(
      catchError((err: any) => throwError(() => err))
    );
  }

  senEmail(data: any): Observable<any> {
    return this.http.post(`${this.QUOTE_TEMPLATE_URL}/quotesListing/senEmail`, data).pipe(
      map((response: any) => {
        return response;
      }),
      catchError((err: any) => throwError(() => err))
    );
  }
  
  get_deleted_quote_listing(): Observable<any> {
    return this.http.get(`${this.QUOTE_TEMPLATE_URL}/quotesListing/getDeletedQuotes`).pipe(
      map((response: any) => {
        return response;
      }),
      catchError((err: any) => throwError(() => err))
    );
  }

  get_void_quote_listing(): Observable<any> {
    return this.http.get(`${this.QUOTE_TEMPLATE_URL}/quotesListing/getVoidQuotes`).pipe(
      map((response: any) => {
        return response;
      }),
      catchError((err: any) => throwError(() => err))
    );
  }

  get_rotten_quote_listing(): Observable<any> {
    return this.http.get(`${this.QUOTE_TEMPLATE_URL}/quotesListing/getRottenQuotes`).pipe(
      map((response: any) => {
        return response;
      }),
      catchError((err: any) => throwError(() => err))
    );
  }

  uploadLogoAttachment(data:any): Observable<any>{
    return this.http.post(`${this.lead}/lead-template/builderImageUpload`, data).pipe(
      map((response: any) => {
        return response;
      }),
     catchError((err: any) => throwError(() => err))
     );
  }
  get_Lead_Form_list(data: any): Observable<any> {
    return this.http.post(`${this.QUOTE_TEMPLATE_URL}/lead-template/templateList`, data).pipe(
      map((response: any) => {
        return response;
      }),
      catchError((err: any) => throwError(() => err))
    );
  }

  uploadItemImages(resource, hideLoader = false) {
    const options = hideLoader ? { headers: { 'X-Hide-Loader': 'true' } } : {};
    return this.http.patch(this.BASE_URL + '/item', resource, options)
      .pipe(
        map((response: any) => {
          return response;
        }),
        catchError((err: any) => throwError(() => err))
      );
  }

  get_Lead_Form_list_All(data: any, hideLoader = false): Observable<any> {
    const options = hideLoader ? { headers: { 'X-Hide-Loader': 'true' } } : {};
    return this.http.post(`${this.QUOTE_TEMPLATE_URL}/lead-template/templateListAll`, data, options).pipe(
      map((response: any) => {
        return response;
      }),
      catchError((err: any) => throwError(() => err))
    );
  }

  // customerCustomFieldList(data: any = ''): Observable<any> {
  //   return this.http.post(this.BASE_URL + '/customercustomfield/list', data).pipe(
  //     map((response: any) => {
  //       return response;
  //     }),
  //     catchError((err: any) => {
  //       return null;
  //     })
  //   );
  // }

  get_eQuote_Form_list(data: any): Observable<any> {
    return this.http.post(`${this.QUOTE_TEMPLATE_URL}/eQuote-template/templateList`, data).pipe(
      map((response: any) => {
        return response;
      }),
      catchError((err: any) => throwError(() => err))
    );
  }

  getQuoteForms_Data(): Observable<any> {
    return this.http.get(`assets/json/quote_form_data.json`).pipe(
      map((response: any) => {
        return response;
      }),
      catchError((err: any) => throwError(() => err))
    );
  }
  getCustomFields(data: any = ''): Observable<any> {
    return this.http.post(environment.API_URL + '/customfield/list', data).pipe(
      map((response: any) => {
        return response;
      }),
      catchError((err: any) => throwError(() => err))
    );
  }
  create_Lead_Form(data: any): Observable<any> {
    return this.http.post(`${this.QUOTE_TEMPLATE_URL}/lead-template/createTemplate`, data).pipe(
      map((response: any) => {
        return response;
      }),
      catchError((err: any) => throwError(() => err))
    );
  }
  set_default_Lead_Form(id: string): Observable<any> {
    return this.http.post(`${this.QUOTE_TEMPLATE_URL}/lead-template/setTemplateDefault/${id}`, {}).pipe(
      map((response: any) => {
        return response;
      }),
      catchError((err: any) => throwError(() => err))
    );
  }
  set_default_eQuote_Form(id: string): Observable<any> {
    return this.http.post(`${this.QUOTE_TEMPLATE_URL}/eQuote-template/setTemplateDefault/${id}`, {}).pipe(
      map((response: any) => {
        return response;
      }),
      catchError((err: any) => throwError(() => err))
    );
  }

  orgcustomFieldList(data: any = ''): Observable<any> {
    return this.http.post(this.QUOTE_TEMPLATE_URL + '/organization/customFieldList', data).pipe(
      map((response: any) => {
        return response;
      }),
      catchError((err: any) => throwError(() => err))
    );
  }
  delete_Lead_Form(id: string): Observable<any> {
    return this.http.post(`${this.QUOTE_TEMPLATE_URL}/lead-template/deleteTemplate/${id}`, {}).pipe(
      map((response: any) => {
        return response;
      }),
      catchError((err: any) => throwError(() => err))
    );
  }

  delete_eQuote_Form(id: string): Observable<any> {
    return this.http.post(`${this.QUOTE_TEMPLATE_URL}/eQuote-template/deleteTemplate/${id}`, {}).pipe(
      map((response: any) => {
        return response;
      }),
      catchError((err: any) => throwError(() => err))
    );
  }

  setCopyTemplateSuffix(suffix: string) {
    this.copyTemplateSuffix = suffix;
  }
  getCopyTemplateSuffix() {
    return this.copyTemplateSuffix;
  }
  getCloneTemplateSuffix() {
    return this.cloneTemplateSuffix;
  }

  get_Quote_Stages(data: any='', hideLoader = false): Observable<any> {
    // hideLoader → opt this GET out of the global SpinnerInterceptor (body flags don't work on GET).
    const options = hideLoader ? { headers: { 'X-Hide-Loader': 'true' } } : {};
    return this.http.get(`${this.QUOTE_TEMPLATE_URL}/quoteStagesList`, options).pipe(
      map((response: any) => {
        return response;
      }),
      catchError((err: any) => throwError(() => err))
    );
  }

  get_Pdf(data: any = ''): Observable<HttpEvent<Blob>> {
    return this.http.post(`${this.QUOTE_TEMPLATE_URL}/quotesListing/downloadPDF`, data, {
      responseType: 'blob',
      reportProgress: true,
      observe: 'events'
    }).pipe(
      catchError((err: any) => {
        throw err;
      })
    );
  }

  

  delete_Quote_Stage(data: any=''): Observable<any> {
    return this.http.post(`${this.QUOTE_TEMPLATE_URL}/deleteStages`,data).pipe(
      map((response: any) => {
        return response;
      }),
      catchError((err: any) => throwError(() => err))
    );
  }

  create_Quote_Stage(data: any=''): Observable<any> {
    return this.http.post(`${this.QUOTE_TEMPLATE_URL}/createStages`,data).pipe(
      map((response: any) => {
        return response;
      }),
      catchError((err: any) => throwError(() => err))
    );
  }

  update_Quote_Stage(data: any=''): Observable<any> {
    return this.http.post(`${this.QUOTE_TEMPLATE_URL}/updateStages`,data).pipe(
      map((response: any) => {
        return response;
      }),
      catchError((err: any) => throwError(() => err))
    );
  }

  update_Quote_Stage_orders(data: any=''): Observable<any> {
    return this.http.post(`${this.QUOTE_TEMPLATE_URL}/updateStagesOrder`,data).pipe(
      map((response: any) => {
        return response;
      }),
      catchError((err: any) => throwError(() => err))
    );
  }


  get_Quote_history(data: any, hideLoader = false): Observable<any> {
    const options = hideLoader ? { headers: { 'X-Hide-Loader': 'true' } } : {};
    return this.http.get(`${this.QUOTE_TEMPLATE_URL}/quotesListing/quotelistingList/${data}`, options).pipe(
      map((response: any) => {
        return response;
      }),
      catchError((err: any) => throwError(() => err))
    );
  }

   create_eQuote_Form(data: any): Observable<any> {
    return this.http.post(`${this.QUOTE_TEMPLATE_URL}/eQuote-template/eQuoteCreate`, data).pipe(
      map((response: any) => {
        return response;
      }),
      catchError((err: any) => throwError(() => err))
    );
  }

  validateContactEmail(data: any): Observable<any> {
    return this.http.post(`${this.QUOTE_TEMPLATE_URL}/eQuote-template/verifyEmail`,data).pipe(
      map((response: any) => {
        return response;
      }),
      catchError((err: any) => throwError(() => err))
    );
  }

  contactInfo(data: any): Observable<any> {
    return this.http.post(`${this.QUOTE_TEMPLATE_URL}/eQuote-template/viewContactInfo`,data).pipe(
      map((response: any) => {
        return response;
      }),
      catchError((err: any) => throwError(() => err))
    );
  }

  customerCustomFields(data: any): Observable<any> {
    return this.http.post(`${this.QUOTE_TEMPLATE_URL}/eQuote-template/customerCustomFields`,data).pipe(
      map((response: any) => {
        return response;
      }),
      catchError((err: any) => throwError(() => err))
    );
  }

  orgCustomFields(data: any): Observable<any> {
    return this.http.post(`${this.QUOTE_TEMPLATE_URL}/eQuote-template/orgCustomFields`,data).pipe(
      map((response: any) => {
        return response;
      }),
      catchError((err: any) => throwError(() => err))
    );
  }

  createEQuoteContact(data: any): Observable<any> {
    return this.http.post(`${this.QUOTE_TEMPLATE_URL}/eQuote-template/eQuoteContact`,data).pipe(
      map((response: any) => {
        return response;
      }),
      catchError((err: any) => throwError(() => err))
    );
  }

  updateEQuoteContact(data: any): Observable<any> {
    return this.http.post(`${this.QUOTE_TEMPLATE_URL}/eQuote-template/eQuoteContactUpdate`,data).pipe(
      map((response: any) => {
        return response;
      }),
      catchError((err: any) => throwError(() => err))
    );
  }

  getOrganization(data: any): Observable<any> {
    return this.http.post(`${this.QUOTE_TEMPLATE_URL}/eQuote-template/orgFind`,data).pipe(
      map((response: any) => {
        return response;
      }),
      catchError((err: any) => throwError(() => err))
    );
  }


  createEQuoteOrg(data: any): Observable<any> {
    return this.http.post(`${this.QUOTE_TEMPLATE_URL}/eQuote-template/eQuoteOrg`,data).pipe(
      map((response: any) => {
        return response;
      }),
      catchError((err: any) => throwError(() => err))
    );
  }


  updateEQuoteOrg(data: any): Observable<any> {
    return this.http.post(`${this.QUOTE_TEMPLATE_URL}/eQuote-template/eQuoteOrgUpdate`,data).pipe(
      map((response: any) => {
        return response;
      }),
      catchError((err: any) => throwError(() => err))
    );
  }

  updateLeadNote(data: any = ''): Observable<any> {
    return this.http.post(`${this.lead}/lead-note/updateEQuoteNote`, data).pipe(
      tap(
        data => data,
        error => error
      )
    );
  }

  merchantUserList(resource:any = '') {
    return this.http.post(this.BASE_URL + '/merchantuser/list', resource)
      .pipe(
        map((response: any) => {
          return response;
        }),
        catchError((err: any) => throwError(() => err))
      );
  }

  merchantCustomerList(resource:any = '') {
    return this.http.post(this.BASE_URL + '/merchantcustomer/list', resource)
      .pipe(
        map((response: any) => {
          return response;
        }),
        catchError((err: any) => throwError(() => err))
      );
  }

  defaultTemplate(data: any): Observable<any> {
    return this.http.post(`${this.QUOTE_TEMPLATE_URL}/lead-template/defaultList`, data).pipe(
      map((response: any) => {
        return response;
      }),
      catchError((err: any) => throwError(() => err))
    );
  }


  formContactList(data: any = ''): Observable<any> {
    return this.http.post(this.BASE_URL + '/formcontacts/list', data).pipe(
      map((response: any) => {
        return response;
      }),
      catchError((err: any) => throwError(() => err))
    );
  }

  getCountryDataFromIp() {
    return this.http.get(`${environment.USER_MANAGEMENT_URL}/ipdata/lookup`).pipe(
      tap(
        data => data,
        error => error
      )
    );
  }
  get_payment_listing_list(data: any): Observable<any> {
    return this.http.post(`${this.QUOTE_TEMPLATE_URL}/paymentsListing/paymentListingList`, data).pipe(
      map((response: any) => {
        return response;
      }),
      catchError((err: any) => throwError(() => err))
    );
  }
  get_payment_listing_list_filters(data: any): Observable<any> {
    return this.http.post(`${this.QUOTE_TEMPLATE_URL}/paymentsListing/paymentListingListFilters`, data).pipe(
      map((response: any) => {
        return response;
      }),
      catchError((err: any) => throwError(() => err))
    );
  }

  createPaymentFilter(data: any): Observable<any> {
    return this.http.post(`${this.QUOTE_TEMPLATE_URL}/quotesPaymentFilters/savefilters`, data).pipe(
      map((response: any) => {
        return response;
      }),
      catchError((err: any) => throwError(() => err))
    );
  }

  savePaymentFilterList(data: any): Observable<any> {
    return this.http.post(`${this.QUOTE_TEMPLATE_URL}/quotesPaymentFilters/saveFilterList`, data).pipe(
      map((response: any) => {
        return response;
      }),
      catchError((err: any) => throwError(() => err))
    );
  }

  deletePaymentFilter(data: any): Observable<any> {
    return this.http.post(`${this.QUOTE_TEMPLATE_URL}/quotesPaymentFilters/deleteSaveFilter`, data).pipe(
      map((response: any) => {
        return response;
      }),
      catchError((err: any) => throwError(() => err))
    );
  }

  create_Payment(data: any): Observable<any> {
    return this.http.post(`${this.QUOTE_TEMPLATE_URL}/paymentsListing/createPayment`,data).pipe(
      map((response: any) => {
        return response;
      }),
      catchError((err: any) => throwError(() => err))
    );
  }

  addTitle(data: any): Observable<any> {
    return this.http.post(`${this.QUOTE_TEMPLATE_URL}/paymentsListing/addTitle`,data).pipe(
      map((response: any) => {
        return response;
      }),
      catchError((err: any) => throwError(() => err))
    );
  }

  findTitle(hideLoader = false): Observable<any> {
    // hideLoader → opt this GET out of the global SpinnerInterceptor (body flags don't work on GET).
    const options = hideLoader ? { headers: { 'X-Hide-Loader': 'true' } } : {};
    return this.http.get(`${this.QUOTE_TEMPLATE_URL}/paymentsListing/findTitle`, options).pipe(
      map((response: any) => {
        return response;
      }),
      catchError((err: any) => throwError(() => err))
    );
  }

  payment_registration(data: any=''): Observable<any> {
    return this.http.post(`${this.QUOTE_TEMPLATE_URL}/quotesListing/payment`,data).pipe(
      map((response: any) => {
        return response;
      }),
      catchError((err: any) => throwError(() => err))
    );
  }

  stripe_keysValidation(data: any=''): Observable<any> {
    return this.http.post(`${this.QUOTE_TEMPLATE_URL}/integrations/stripe/keys`,data).pipe(
      map((response: any) => {
        return response;
      }),
      catchError((err: any) => throwError(() => err))
    );
  }

  twilio_keysValidation(data: any=''): Observable<any> {
    return this.http.post(`${this.QUOTE_TEMPLATE_URL}/integrations/twilio/keys`,data).pipe(
      map((response: any) => {
        return response;
      }),
      catchError((err: any) => throwError(() => err))
    );
  }

  meta_keysValidation(data: any=''): Observable<any> {
    return this.http.post(`${this.QUOTE_TEMPLATE_URL}/integrations/meta/keys`,data).pipe(
      map((response: any) => {
        return response;
      }),
      catchError((err: any) => throwError(() => err))
    );
  }


  integrations(data: any='', hideLoader = false): Observable<any> {
    // hideLoader → opt out of the global SpinnerInterceptor via header, without touching the body.
    const options = hideLoader ? { headers: { 'X-Hide-Loader': 'true' } } : {};
    return this.http.post(`${this.QUOTE_TEMPLATE_URL}/integrations/create`, data, options).pipe(
      map((response: any) => {
        return response;
      }),
      catchError((err: any) => throwError(() => err))
    );
  }

  integrations_nonActive(data: any=''): Observable<any> {
    return this.http.post(`${this.QUOTE_TEMPLATE_URL}/integrations/non-active`,data).pipe(
      map((response: any) => {
        return response;
      }),
      catchError((err: any) => throwError(() => err))
    );
  }

  getKeys(data: any=''): Observable<any> {
    return this.http.post(`${this.QUOTE_TEMPLATE_URL}/integrations/getKeys`,data).pipe(
      map((response: any) => {
        return response;
      }),
      catchError((err: any) => throwError(() => err))
    );
  }

  update_status_paid(data: any): Observable<any> {
    return this.http.post(`${this.QUOTE_TEMPLATE_URL}/quotesPdf/updateStatusPaid`, data).pipe(
      map((response: any) => {
        return response;
      }),
      catchError((err: any) => throwError(() => err))
    );
  }

  viewPayment(data: any): Observable<any> {
    return this.http.get(`${this.QUOTE_TEMPLATE_URL}/paymentsListing/viewPaymentPop/${data}`).pipe(
      map((response: any) => {
        return response;
      }),
      catchError((err: any) => throwError(() => err))
    );
  }

  sendWhatsApp(data: any): Observable<any> {
    return this.http.post(`${this.QUOTE_TEMPLATE_URL}/quotesListing/sendWhatsApp`,data).pipe(
      map((response: any) => {
        return response;
      }),
      catchError((err: any) => throwError(() => err))
    );
  }

  get_Quote(): Observable<any> {
    return this.http.get(`${this.QUOTE_TEMPLATE_URL}/quotesListing/getQuotes`).pipe(
      map((response: any) => {
        return response;
      }),
      catchError((err: any) => throwError(() => err))
    );
  }

  updateInventory(data: any=''): Observable<any> {
    return this.http.post(`${this.ITEMS}/item/updateInventory`,data).pipe(
      map((response: any) => {
        return response;
      }),
      catchError((err: any) => throwError(() => err))
    );
  }

  revertInventory(data: any=''): Observable<any> {
    return this.http.post(`${this.ITEMS}/item/revertInventory`,data).pipe(
      map((response: any) => {
        return response;
      }),
      catchError((err: any) => throwError(() => err))
    );
  }

  save_quote_history(data: any): Observable<any> {
    return this.http.post(`${this.QUOTE_TEMPLATE_URL}/quotesListing/quoteHistory`, data).pipe(
      map((response: any) => {
        return response;
      }),
      catchError((err: any) => throwError(() => err))
    );
  }

  get_quote_history(data: any): Observable<any> {
    return this.http.post(`${this.QUOTE_TEMPLATE_URL}/quotesListing/getQuoteHistory`, data).pipe(
      map((response: any) => {
        return response;
      }),
      catchError((err: any) => throwError(() => err))
    );
  }

  sales_invoice(data: any = ''): Observable<any> {
    const payload = typeof data === 'object' && data !== null ? { timezone: browserTimeZone(), ...data } : data;
    return this.http.post(`${this.QUOTE_TEMPLATE_URL}/quotesListing/sales_invoice`, payload).pipe(
      map((response: any) => {
        return response;
      }),
      catchError((err: any) => throwError(() => err))
    );
  }

  get_void_invoice(data: any): Observable<any> {
    return this.http.get(`${this.QUOTE_TEMPLATE_URL}/quotesListing/getVoidInvoice/${data}`).pipe(
      map((response: any) => {
        return response;
      }),
      catchError((err: any) => throwError(() => err))
    );
  }

  get_items_inventory(data: InventoryRequest): Observable<ItemViewModel[]> {
    if(data?.ids?.length){
      return this.http.post<{ status: number; data: ItemViewModel[] }>(`${this.ITEMS}/item/getInventory`, data).pipe(
        map((response) => response?.data),
        catchError((error:HttpErrorResponse) => {
          // Optional: show user notification (use your own notification service)
          this.snackbar.open(this.translateService.instant('Snackbar.Failed to load inventory items. Please try again later.'),"Error", {duration: 3000} );
    
          // Option 1: Return fallback empty array to continue app flow
          return of([]);
        })
      );
    }else{
      return of([]);
    }
    }

    get_Quote_Pending_Stage(data:any=''): Observable<any> { 
      return this.http.post(this.QUOTE_TEMPLATE_URL +'/getPendingStage',data).pipe(
        map((response: any) => {
          return response;
        }),
        catchError((err: any) => throwError(() => err))
      );
    }

    send_Api_Request(data: any=''): Observable<any> {
      return this.http.post(`${this.QUOTE_TEMPLATE_URL}/quotesListing/sendApiEmail`,data).pipe(
        map((response: any) => {
          return response;
        }),
        catchError((err: any) => throwError(() => err))
      );
    }

    get_all_quote_listing(): Observable<any> {
      return this.http.get(`${this.QUOTE_TEMPLATE_URL}/quotesListing/getAllQuote`).pipe(
        map((response: any) => {
          return response;
        }),
        catchError((err: any) => throwError(() => err))
      );
    }

    saveWhatsApp(data: any): Observable<any> {
      return this.http.post(`${this.QUOTE_TEMPLATE_URL}/quotesListing/saveWhatsappData`,data).pipe(
        map((response: any) => {
          return response;
        }),
        catchError((err: any) => throwError(() => err))
      );
    }

    getWhatsAppTem(data: any): Observable<any> {
      return this.http.post(`${this.QUOTE_TEMPLATE_URL}/quotesListing/getWhatsAppTem`,data).pipe(
        map((response: any) => {
          return response;
        }),
        catchError((err: any) => throwError(() => err))
      );
    }
  
    get_quote_whatsapp(hideLoader = false): Observable<any> {
      const options = hideLoader ? { headers: { 'X-Hide-Loader': 'true' } } : {};
      return this.http.get(`${this.QUOTE_TEMPLATE_URL}/quotesListing/getQuoteWhatsapp`, options).pipe(
        map((response: any) => {
          return response;
        }),
        catchError((err: any) => throwError(() => err))
      );
    }

    /**
     * The body for a Reports endpoint, carrying the browser's time zone so the server
     * reads presets and whole days in it. Most Reports callers pass nothing ('') and
     * used to post an empty body, so those calls (and quoteToSales / getSalesTeam)
     * fell back to the UTC server clock. A body the caller built is kept as it is,
     * including a timezone it set itself.
     */
    private withReportsTimeZone(data: any): any {
      if (data !== null && typeof data === 'object' && !Array.isArray(data)) return { timezone: browserTimeZone(), ...data };
      if (data === '' || data === undefined || data === null) {
        const timezone = browserTimeZone();
        return timezone ? { timezone } : data;
      }
      return data;
    }

    get_reporting_data_list(data: any=''): Observable<any> {
      return this.http.post(`${this.QUOTE_TEMPLATE_URL}/reporting/salesOverView`, this.withReportsTimeZone(data)).pipe(
        map((response: any) => {
          return withPlotDate(response); // card #281: adds plot_date (the sale day); changes nothing else
        }),
        catchError((err: any) => throwError(() => err))
      );
    }

    get_quote_to_sales_list(data: any=''): Observable<any> {
      return this.http.post(`${this.QUOTE_TEMPLATE_URL}/reporting/quoteToSales`, this.withReportsTimeZone(data)).pipe(
        map((response: any) => {
          return response;
        }),
        catchError((err: any) => throwError(() => err))
      );
    }

    create_reports_filters(data: any): Observable<any> {
      return this.http.post(`${this.QUOTE_TEMPLATE_URL}/reporting/createReportFilters`,data).pipe(
        map((response: any) => {
          return response;
        }),
        catchError((err: any) => throwError(() => err))
      );
    }

    get_reporting_filter_data(data: any=''): Observable<any> {
      return this.http.post(`${this.QUOTE_TEMPLATE_URL}/reporting/getFilterData`,data).pipe(
        map((response: any) => {
          return response;
        }),
        catchError((err: any) => throwError(() => err))
      );
    }

    get_reporting_filter_datas(data: any=''): Observable<any> {
      return this.http.post(`${this.QUOTE_TEMPLATE_URL}/reporting/getFilterAllData`, this.withReportsTimeZone(data)).pipe(
        map((response: any) => {
          return response;
        }),
        catchError((err: any) => throwError(() => err))
      );
    }

    get_reporting_filter_data_by_id(data: any=''): Observable<any> {
      return this.http.post(`${this.QUOTE_TEMPLATE_URL}/reporting/getFilterAllDataById`,data).pipe(
        map((response: any) => {
          return response;
        }),
        catchError((err: any) => throwError(() => err))
      );
    }

    get_new_quotes(data: any=''): Observable<any> {
      // Card #281: the page's time zone, so the range it now sends is read as its own days.
      return this.http.post(`${this.QUOTE_TEMPLATE_URL}/reporting/getFilterDataNewQuotes`, this.withReportsTimeZone(data)).pipe(
        map((response: any) => {
          return response;
        }),
        catchError((err: any) => throwError(() => err))
      );
    }

    get_sales_forecast(data: any=''): Observable<any> {
      return this.http.post(`${this.QUOTE_TEMPLATE_URL}/reporting/getSalesForecast`,data).pipe(
        map((response: any) => {
          return response;
        }),
        catchError((err: any) => throwError(() => err))
      );
    }

    get_sales_team(data: any=''): Observable<any> {
      return this.http.post(`${this.QUOTE_TEMPLATE_URL}/reporting/getSalesTeam`, this.withReportsTimeZone(data)).pipe(
        map((response: any) => {
          return response;
        }),
        catchError((err: any) => throwError(() => err))
      );
    }

    get_sales_tax(data: any=''): Observable<any> {
      return this.http.post(`${this.QUOTE_TEMPLATE_URL}/reporting/getSalesTax`,data).pipe(
        map((response: any) => {
          return response;
        }),
        catchError((err: any) => throwError(() => err))
      );
    }

    delete_reporting_filters(data: any): Observable<any> {
      return this.http.post(`${this.QUOTE_TEMPLATE_URL}/reporting/deleteFilters`,data).pipe(
        map((response: any) => {
          return response;
        }),
        catchError((err: any) => throwError(() => err))
      );
    }

    get_quote_length(data: any=''): Observable<any> {
      return this.http.get(`${this.QUOTE_TEMPLATE_URL}/quotesListing/getQuoteLength`,data).pipe(
        map((response: any) => {
          return response;
        }),
        catchError((err: any) => throwError(() => err))
      );
    }

    get_all_payments(data: any=''): Observable<any> {
      return this.http.get(`${this.QUOTE_TEMPLATE_URL}/quotesListing/getAllPayments`,data).pipe(
        map((response: any) => {
          return response;
        }),
        catchError((err: any) => throwError(() => err))
      );
    }

    get_quote_sales_invoice_payments(data: any=''): Observable<any> {
      return this.http.get(`${this.QUOTE_TEMPLATE_URL}/quotesListing/getAllNumbers`,data).pipe(
        map((response: any) => {
          return response;
        }),
        catchError((err: any) => throwError(() => err))
      );
    }

    get_all_commissions(data: any=''): Observable<any> {
      return this.http.post(`${this.QUOTE_TEMPLATE_URL}/quotesListing/getAllCommissions`,data).pipe(
        map((response: any) => {
          return response;
        }),
        catchError((err: any) => throwError(() => err))
      );
    }

    get_KPI_widgets_data(data: any=''): Observable<any> {
      return this.http.post(`${this.QUOTE_TEMPLATE_URL}/quotesListing/getKPIWidgetsData`, this.withReportsTimeZone(data)).pipe(
        map((response: any) => {
          return response;
        }),
        catchError((err: any) => throwError(() => err))
      );
    }

    get_contacts_tags_data(data: any=''): Observable<any> {
      return this.http.get(`${this.QUOTE_TEMPLATE_URL}/quotesListing/getContactTags`,data).pipe(
        map((response: any) => {
          return response;
        }),
        catchError((err: any) => throwError(() => err))
      );
    }
  
    get_corporate_rate(data: any=''): Observable<any> {
      return this.http.post(`${this.QUOTE_TEMPLATE_URL}/reporting/getCorporateRate`,data).pipe(
        map((response: any) => {
          return response;
        }),
        catchError((err: any) => throwError(() => err))
      );
    }

    saveWorkspaceCustomization(data: any): Observable<any> {
      return this.http.post(`${this.QUOTE_TEMPLATE_URL}/quotesListing/saveWorkSpaceCustomization`,data).pipe(
        map((response: any) => {
          return response;
        }),
        catchError((err: any) => throwError(() => err))
      );
    }

    get_work_space_customization(data: any=''): Observable<any> {
      return this.http.get(`${this.QUOTE_TEMPLATE_URL}/quotesListing/getWorkSpaceCustomization`,data).pipe(
        map((response: any) => {
          return response;
        }),
        catchError((err: any) => throwError(() => err))
      );
    }

    getCoachingWidgetRequest(): Observable<any> {
      return this.http.get(`${this.QUOTE_TEMPLATE_URL}/quotesListing/coaching-widget`).pipe(
        map((response: any) => {
          return response;
        }),
        catchError((err: any) => throwError(() => err))
      );
    }

    /** Card #582: one page of a quote's History drawer (quotes#596's `GET quoteLogs/:quoteId`). */
    getQuoteLogs(quoteId: string, filter: QuoteLogFilter, offset: number): Observable<QuoteLogResponse> {
      return this.http.get<QuoteLogResponse>(`${this.QUOTE_TEMPLATE_URL}/quoteLogs/${encodeURIComponent(quoteId)}`, {
        params: { filter, offset },
      });
    }

}
